import MapElementProps from "../MapElementProps";
import {useEffect} from "react";
import './MapStyleControl.scss';
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {selectMapStyle, styleChanged} from "../../../redux/features/map/slice";
import MapIControl from "./MapIControl";
import {track} from "../../../helpers/analytics";
import { t } from "../../../i18n";

const MapStyleControl = ({map}: MapElementProps) => {
    const mapStyle = useAppSelector(selectMapStyle);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!map) return;
        // Don't call setStyle until the map has finished its initial load.
        // Calling it before load races with the constructor's style fetch and
        // produces "Unable to perform style diff" + "send" errors.
        if (map.isStyleLoaded()) {
            map.setStyle(mapStyle);
        } else {
            const onLoad = () => map.setStyle(mapStyle);
            map.once('load', onLoad);
            return () => { map.off('load', onLoad); };
        }
    }, [map, mapStyle])

    // `name` feeds the asset path + analytics event (do not localize);
    // `label` is the user-visible alt text, resolved at render time.
    const styles = [
        // "Paper" (light-v11) leads — the Canvas Sticker default canvas.
        {name: 'light', url: 'mapbox://styles/mapbox/light-v11', label: t('web.map.stylePaper')},
        {name: 'streets', url: 'mapbox://styles/mapbox/streets-v12', label: t('web.map.styleStreets')},
        {name: 'outdoors', url: 'mapbox://styles/mapbox/outdoors-v12', label: t('web.map.styleOutdoors')},
        {name: 'dark', url: 'mapbox://styles/mapbox/dark-v11', label: t('web.map.styleDark')},
        // {name: 'satellite', url: 'mapbox://styles/mapbox/satellite-v9'}, // not a globe
        {name: 'satellite-streets', url: 'mapbox://styles/mapbox/satellite-streets-v12', label: t('web.map.styleSatelliteStreets')},
        // {name: 'day', url: 'mapbox://styles/mapbox/navigation-day-v1'},
        // {name: 'night', url: 'mapbox://styles/mapbox/navigation-night-v1'}, // not a globe
    ];

    return (
            <MapIControl map={map!} position='top-right' doShow={() => true} className='map-style-ctrl'>
                {
                    styles.map(v =>
                            <div key={v.name}
                                 className={'style-div' + (mapStyle == v.url ? ' style-div-selected' : '')}>
                                <div>
                                    <button onClick={() => {
                                        track('map_style_changed', { style: v.name });
                                        map!.setStyle(v.url);
                                        map!.once('styledata', () => {
                                            dispatch(styleChanged(v.url));
                                        })
                                    }}>
                                        <img src={`/map/styles/${v.name}.png`} alt={v.label}/>
                                    </button>
                                </div>
                            </div>)
                }
            </MapIControl>
    );
}

export default MapStyleControl;